import React from 'react';
import './styles/CTAButtonInvert.css';

function CTAButtonInvert({ text, onClick }) {
  return (
    <button className="cta-button-invert" onClick={onClick}>
      <span className="cta-text-invert">{text}</span>
      <span className="cta-icon-invert">→</span>
    </button>
  );
}

export default CTAButtonInvert;
